import { render } from "./ConfVociPreferiteGenerali.vue?vue&type=template&id=6c534252&scoped=true"
import script from "./ConfVociPreferiteGenerali.vue?vue&type=script&lang=js"
export * from "./ConfVociPreferiteGenerali.vue?vue&type=script&lang=js"

import "./ConfVociPreferiteGenerali.vue?vue&type=style&index=0&id=6c534252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c534252"]])

export default __exports__